import React from 'react'
import * as Yup from 'yup'
import { withFormik } from 'formik'
import { Input, TextErrorInput, Button } from '@provi/provi-components'
import { Form } from '../../../components/form'

export const Formik = props => {
  const { handleChange, values, errors, touched, handleBlur, handleSubmit } = props

  return (
    <Form onSubmit={handleSubmit}>
      <Input
        autoFocus
        margin="normal"
        id="name"
        placeholder="Pode escrever mais que um tweet, tá?"
        onChange={handleChange('courseReason')}
        onBlur={handleBlur('courseReason')}
        error={!!errors.courseReason}
        value={values.courseReason}
      />
      {errors.courseReason && touched.courseReason && <TextErrorInput text={errors.courseReason} />}

      <Button
        marginHorizontal={0}
        type="submit"
        disabled={errors.courseReason || !values.courseReason}
        text="Avançar"
        persistFloatingMode={false}
      />
    </Form>
  )
}

export const FormFomik = withFormik({
  validateOnBlur: false,
  validateOnChange: true,
  enableReinitialize: true,
  mapPropsToValues: props => ({ courseReason: props.data || '' }),
  validationSchema: Yup.object().shape({
    courseReason: Yup.string()
      .min(5, 'A resposta deve conter no mínimo 5 caracteres')
      .max(2048, 'A resposta deve conter no máximo 2048 caracteres')
      .required('Digite um texto válido')
  }),
  handleSubmit: async ({ courseReason }, { setSubmitting, props }) => {
    props.goToNextScreen(courseReason)
    setSubmitting(false)
  }
})(Formik)
